module.exports = __webpack_public_path__ + "static/media/1POLICY34.157ff4a7.jpg";